import {
  AnnotationsModuleClient,
  ConvertModuleClient,
  CustomerModuleClient,
  HealthModuleClient,
  Models3dModuleClient,
  ProjectsModuleClient,
  SavedViewsModuleClient,
  StripeModuleClient,
  SubscriptionsModuleClient,
  XEO_AUTHORIZATION_HEADER,
  getProjectCredentials,
} from '@xeovision/shared';

import axios from 'axios';

export const useHttpClientStore = defineStore('http-client-store', () => {
  const projectId = ref<string | null>(null);
  const config = useRuntimeConfig();
  const client = axios.create({
    baseURL: config.public.XEOVISION_API_ENDPOINT,
    withCredentials: true,
  });

  // Created due nuxt warning about not using useRoute within middleware
  const setProjectId = (id: string) => {
    projectId.value = id;
  };

  client.interceptors.request.use(async (config) => {
    // Refreshes an (almost) expired token first, so the API never sees a stale Bearer (401).
    const accessToken = await useAuthClientStore().getValidAccessToken();
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    if (projectId.value) {
      const xeoAuthorizationToken = getProjectCredentials(projectId.value);
      if (xeoAuthorizationToken) {
        config.headers[XEO_AUTHORIZATION_HEADER] = `Bearer ${xeoAuthorizationToken}`;
      }
    }
    return config;
  });

  // clients
  const convert = new ConvertModuleClient(client);
  const health = new HealthModuleClient(client);
  const models3d = new Models3dModuleClient(client);
  const projects = new ProjectsModuleClient(client);
  const annotations = new AnnotationsModuleClient(client);
  const savedViews = new SavedViewsModuleClient(client);
  const subscriptions = new SubscriptionsModuleClient(client);
  const customer = new CustomerModuleClient(client);
  const stripe = new StripeModuleClient(client);

  return {
    projectId,
    setProjectId,
    client,
    convert,
    health,
    models3d,
    projects,
    annotations,
    savedViews,
    subscriptions,
    customer,
    stripe,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useHttpClientStore, import.meta.hot));
}
